import attachIcon from 'assets/image/icons/svg/attach.svg'
import imageIcon from 'assets/image/icons/svg/image-icon.svg'
import { type FormEvent, useId } from 'react'
import { a11y } from 'shared/styles'

import { useUploadFile } from './hooks'

function Upload({
    accept,
    icon,
    label
}: {
    accept: string
    icon: 'file' | 'image'
    label: string
}) {
	const id = useId()
	const uploadFile = useUploadFile()

	async function handleInput(event: FormEvent<HTMLInputElement>) {
		const input = event.currentTarget
		const files = input.files

		if (files?.length) {
			uploadFile(files[0])
			input.value = ''
		}
	}

	return (
		<>
			<input
				accept={accept}
				className={a11y.hidden}
				id={id}
				onInput={handleInput}
				type='file'
			/>
            <label aria-label={label} className='li-⚪' htmlFor={id} title={label}>
                {icon === 'file' ? (
                    <img alt='' aria-hidden height={20} src={attachIcon} width={20} />
                ) : (
                    <img alt='' aria-hidden height={20} src={imageIcon} width={20} />
                )}
            </label>
		</>
	)
}

const UploadFile = () => (
	<Upload
		accept='image/*,.ai,.psd,.pdf,.doc,.docx,.csv,.zip,.rar,.ppt,.pptx,.pps,.ppsx,.odt,.rtf,.xls,.xlsx,.txt,.pub,.html,.7z,.eml,.mov,.mp4'
        icon='file'
		label='Attach a file to this conversation'
	/>
)
const UploadImage = () => (
	<Upload
		accept='image/*'
        icon='image'
		label='Attach an image to this conversation'
	/>
)

export { UploadFile, UploadImage }
